import React from 'react';
import { useSelector } from 'react-redux';

import { RoleEnum, VideoApprovalStatusEnum } from 'js/src/client';
import { isApprovalWorkflowRestricted } from 'js/src/data/account';
import type { RootState } from 'js/src/libs/RootState';

export const approvalStatusDisabledButtonProps = {
    disabled: true,
    tooltipTitle: 'An admin needs to approve this video before it can be published.',
};

const useDownloadVideoPermissions = (
    videoApprovalStatus: VideoApprovalStatusEnum | null,
): boolean => {
    const [canDownload, setCanDownload] = React.useState<boolean>(true);
    const approvalWorkflowEnabled = useSelector((state: RootState) =>
        isApprovalWorkflowRestricted(state),
    );

    React.useEffect(() => {
        // if an admin turns on approval workflow && status !== approved, editors cannot download
        if (
            SERVER.USER?.role === RoleEnum.EDITOR &&
            approvalWorkflowEnabled &&
            videoApprovalStatus !== VideoApprovalStatusEnum.APPROVED
        ) {
            setCanDownload(false);
        } else {
            setCanDownload(true);
        }
    }, [approvalWorkflowEnabled, videoApprovalStatus]);

    return canDownload;
};

export default useDownloadVideoPermissions;
